import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DigitalDisplayService {


  endpoint: any;
  leaflogixendpoint: any;
  menuEndpoint: any;
  orderEndpoint: any;
  storeId: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  storeType: any;
  constructor(private http: HttpClient,) {
    this.storeId = localStorage.getItem('currentStore');
    this.storeType = localStorage.getItem('store_type');
    let idInt = parseInt(this.storeId);
    this.endpoint = environment.apiUrl;
    this.menuEndpoint = `${this.endpoint}/backend/`;
    this.leaflogixendpoint = `${environment.leaflogixApiEndpoint}/pos-display/`;

    // setInterval(() => {
    //   this.storeId = localStorage.getItem('currentStore');
    //   this.storeType = localStorage.getItem('store_type');

    //   if (this.storeType == 'Leaflogix') {
    //     this.orderEndpoint = this.leaflogixendpoint;
    //   }
    //   else {
    //     this.orderEndpoint = this.menuEndpoint;
    //   }
    // }, 4000);

    // orderEndpoint used to stay undefined until callDigitalModule() ran, and the
    // only thing that runs it is StoreService.changeStore() — which on a page
    // refresh does not fire until the shell's getStores() request comes back. A
    // panel that loaded before that built its URL as `${undefined}screen/163/`,
    // i.e. the relative "undefinedscreen/163/", and since these callers pass no
    // error handler their spinner never stopped. The store type is already in
    // localStorage on refresh, so seed from it here; changeStore() still
    // overrides this the moment a different store is picked.
    this.callDigitalModule(this.storeType);
  }

  callDigitalModule(storeType: any) {
    if (storeType == 'Leaflogix') {
      this.orderEndpoint = this.leaflogixendpoint;
    }
    else {
      this.orderEndpoint = this.menuEndpoint;
    }
  }

  unreadMessages(storeId: any) {
    this.storeId = localStorage.getItem('currentStore');
    this.storeType = localStorage.getItem('store_type');
    let idInt = parseInt(this.storeId);
    this.endpoint = environment.apiUrl;
    this.menuEndpoint = `${this.endpoint}/backend/`;
    this.leaflogixendpoint = `${environment.leaflogixApiEndpoint}/pos-display/`;
    if (this.storeType == 'Leaflogix') {
      this.orderEndpoint = this.leaflogixendpoint;
    }
    else {
      this.orderEndpoint = this.menuEndpoint;
    }
  }

  getDisplayScreen(storeId: string) {
    // ENG-5986: the backend now leaves inactive screens out of this list for the Howl TV app; the
    // console asks for every screen, active or not, so every page here shows them as before.
    return this.http.get<any>(
      `${this.orderEndpoint}screen/${storeId}/?include_inactive=1`
    );
  }

  /** ENG-5986: mark a screen Active / Inactive (restaurant stores; Howl lists only active ones). */
  setScreenActive(id: number, isActive: boolean) {
    return this.http.post<{ id: number; is_active: boolean }>(
      `${environment.apiUrl}/backend/screen/active/${id}/`, { is_active: isActive }
    );
  }

  /** ENG-5986: mark a TV Active / Inactive (restaurant stores; Howl lists only active ones). */
  setTvActive(id: number, isActive: boolean) {
    return this.http.post<{ id: number; is_active: boolean }>(
      `${environment.apiUrl}/backend/tv/active/${id}/`, { is_active: isActive }
    );
  }


  deleteDisplayScreen(Id: any) {
    return this.http.delete<any>(
      `${this.orderEndpoint}screen/${Id}/`
    );
  }

  copyMenuCat(data) {
    return this.http.post<any>(
      `${this.orderEndpoint}mastercategories/copy/`, data,
    );
  }

  deleteScreen(Id: any) {
    return this.http.delete<any>(
      `${this.orderEndpoint}screen/${Id}/`
    );
  }

  editDisplayScreen(Id: any, data) {
    return this.http.put<any>(
      `${this.orderEndpoint}screen/${Id}/`, data,
    );
  }

  AdvanceCssScreen(Id: any, data) {
    return this.http.put<any>(
      `${this.orderEndpoint}screen/advance/css/${Id}/`, data,
    );
  }

  GetAdvanceCssScreen(Id: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}screen/advance/css/${Id}/`,
    );
  }


  copyDisplayScreen(storeId: string, Id: any) {
    return this.http.post<any>(
      `${this.orderEndpoint}screen/copy/${storeId}/${Id}/`, '',
    );
  }

  addDisplayScreen(data) {
    return this.http.post<any>(
      `${this.orderEndpoint}add/screen/`, data,
    );
  }

  getMasterCategory(storeId: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}mastercategories/${storeId}/`
    );
  }

  /**
   * Exact count of menu rows the store's MENU screens will render (master
   * categories + sub-categories + items + modifiers), computed by the backend
   * using the real distribution logic. Used to size the AI-built menu board:
   * screens_needed = ceil(total_rows / rows_per_screen). Main backend only.
   */
  getMenuRowCount(storeId: any, rowsPerScreen: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/menu-row-count/${storeId}/?rows_per_screen=${rowsPerScreen}`
    );
  }

  /**
   * Create one IMAGE/VIDEO screen and slot it into the running order (after a
   * chosen screen), re-sequencing tv_ids and adding it to the neighbour's TV
   * rotation — all done atomically on the backend.
   */
  insertMediaScreen(payload: any) {
    return this.http.post<any>(`${environment.apiUrl}/backend/insert-media-screen/`, payload);
  }

  /**
   * Auto-fit the fonts on EVERY menu screen of one TV (deterministic — sizes
   * each screen's fonts to its height/rows and refreshes the master-category
   * font in advance_css). dry_run returns what it would set without saving.
   */
  autoFitTv(payload: any) {
    return this.http.post<any>(`${environment.apiUrl}/backend/auto-fit-tv/`, payload);
  }

  fileSizeLimit(storeId: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}pos/display/store/file/size/${storeId}/`
    );
  }

  addMasterCategory(payload: any) {
    return this.http.post(`${this.orderEndpoint}add/mastercategory/`, payload, this.httpOptions);
  }

  editMasterCategory(Id: any, data) {
    return this.http.put<any>(
      `${this.orderEndpoint}mastercategories/${Id}/`, data,
    );
  }

  deleteMasterCategory(Id: any) {
    return this.http.delete<any>(
      `${this.orderEndpoint}mastercategories/${Id}/`
    );
  }

  subCategoryList(Id: any) {
    return this.http.get(`${this.orderEndpoint}menuitem/option/list/${Id}/`, this.httpOptions);
  }

  SubCategoriesOtionListMaster(storeId: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}sub_cat/menu/option/list/${storeId}/`
    );
  }
  ModifierGroupOtionListMaster(storeId: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}modifier/menu/group/option/list/${storeId}/`
    );
  }

  ImageMediaListGet(storeId: any) {
    return this.http.get<any>(`${this.orderEndpoint}screen/image/${storeId}/`);
  }
  addMedia(payload: any) {
    return this.http.post(`${this.orderEndpoint}screen/image/add/`, payload);
  }

  editMedia(payload: any, Id: any) {
    return this.http.put(`${this.orderEndpoint}screen/image/${Id}/update/`, payload);
  }

  deleteMedia(Id: any) {
    return this.http.delete(`${this.orderEndpoint}screen/image/${Id}/delete/`);
  }

  restaurantListGet(storeId: any) {
    return this.http.get<any>(`${this.orderEndpoint}cat/image/${storeId}/`);
  }
  addrestauran(payload: any) {
    return this.http.post(`${this.orderEndpoint}cat/image/add/`, payload);
  }
  editrestauran(payload: any, Id: any) {
    return this.http.put(`${this.orderEndpoint}cat/image/${Id}/`, payload);
  }
  deleterestauran(Id: any) {
    return this.http.delete(`${this.orderEndpoint}cat/image/${Id}/`);
  }

  videoListGet(storeId: any) {
    return this.http.get<any>(`${this.orderEndpoint}screen/video/${storeId}/`);
  }
  addVideo(payload: any) {
    return this.http.post(`${this.orderEndpoint}screen/video/add/`, payload);
  }

  editVideo(payload: any, Id: any) {
    return this.http.put(`${this.orderEndpoint}screen/video/${Id}/`, payload);
  }

  deleteVideo(Id: any) {
    return this.http.delete(`${this.orderEndpoint}screen/video/${Id}/`);
  }

  getEmojiList() {
    return this.http.get(`${this.orderEndpoint}list/emoji/`);
  }



  editCategory(Id: any, data) {
    return this.http.put<any>(
      `${this.orderEndpoint}update/category/${Id}/`, data,
    );
  }
  deleteCategory(Id: any) {
    return this.http.delete<any>(
      `${this.orderEndpoint}delete/category/${Id}/`
    );
  }


  editSubCategory(Id: any, data) {
    return this.http.put<any>(
      `${this.orderEndpoint}update/subcategory/${Id}/`, data,
    );
  }

  CategoriesOtionList(storeId: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}categories/option/list/${storeId}/`
    );
  }

  SubCategoriesOtionList(storeId: any) {
    return this.http.get<any>(
      `${this.orderEndpoint}subcategories/option/list/${storeId}/`
    );
  }

  getCheckCategories(storeId: any) {
    return this.http.get<any>(`${this.orderEndpoint}check_categories/${storeId}/`);
  }

  subCategoriesAdd(storeId: any) {
    return this.http.get<any>(`${this.orderEndpoint}save/category/${storeId}/`);
  }

  addCategory(payload: any) {
    return this.http.post(`${this.orderEndpoint}add/category/`, payload, this.httpOptions);
  }
  addSubCategory(payload: any) {
    return this.http.post(`${this.orderEndpoint}add/subcategory/`, payload, this.httpOptions);
  }
  defaultScreenList() {
    return this.http.get<any>(`${this.orderEndpoint}default/screens/`);
  }
  defaultScreenSet(data) {
    return this.http.post<any>(`${this.orderEndpoint}default/screens/`, data);
  }
  newScreenSet(data) {
    return this.http.post<any>(`${this.orderEndpoint}default/to/new/screens/`, data);
  }
  addTVScreen(data) {
    return this.http.post<any>(`${this.orderEndpoint}tv/screens/`, data);
  }
  updateTVScreen(Id, data) {
    return this.http.put<any>(`${this.orderEndpoint}tv/screens/${Id}/`, data);
  }

  getTVScreen(storeId) {
    return this.http.get<any>(`${this.orderEndpoint}tv/screens/${storeId}/`);
  }

  deleteTVScreen(Id: any) {
    return this.http.delete<any>(
      `${this.orderEndpoint}tv/screens/${Id}/`
    );
  }

  getdefaultMenuCategorie(storeId) {
    return this.http.get<any>(`${this.orderEndpoint}default/mastercategories/${storeId}/`);
  }
  updatedefaultMenuCategorie(Id, data) {
    return this.http.put<any>(`${this.orderEndpoint}default/mastercategories/${Id}`, data);
  }
  deletedefaultMenuCategorie(Id) {
    return this.http.delete<any>(`${this.orderEndpoint}default/mastercategories/${Id}/`);
  }
  defaultToNewMenuCategory(data: any) {
    return this.http.post<any>(`${this.orderEndpoint}default/mastercategories/to/mastercategories/`, data);
  }

  dragdropMasterCategory(payload: any) {
    return this.http.post(`${this.orderEndpoint}drag_and_drop/mastercategories/`, payload, this.httpOptions);
  }

  setDefaultCategory(payload: any) {
    return this.http.put(`${this.orderEndpoint}set/default/mastercategory/`, payload, this.httpOptions);
  }

  applyDefaultSetting(payload: any) {
    return this.http.put(`${this.orderEndpoint}synk/default/mastercategory/`, payload, this.httpOptions);
  }

  refressDisplayScreen(storeId: string) {
    return this.http.get<any>(
      `${this.orderEndpoint}store/cache-update/${storeId}/`
    );
  }

  /**
   * ENG-5094: lists the physical Android TV boxes registered for a store
   * (see howl_remote app, backend). Used by the "Remote TV" tab to pick a
   * device to view/control — see remote-tv.component.ts.
   */
  getHowlDevices(storeId: string) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/api/howl_devices/${storeId}/`
    );
  }

  // ENG-5629: name a TV box from the Remote TV tab. An empty label clears the
  // name; the box then shows its default ("<model> · <last 4 of id>").
  renameHowlDevice(storeId: string, deviceId: string, label: string) {
    return this.http.patch<any>(
      `${environment.apiUrl}/backend/api/howl_devices/${storeId}/${deviceId}/`,
      { label }
    );
  }

  // ENG-5235: designs supplied as HTML by a client, resolved server-side into
  // one board per TV (see screen_import app on the backend). A separate path
  // from generated menu screens — these carry finished markup rather than the
  // style fields screen.html renders from.

  getImportedDesigns(storeId: string) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/?store_id=${storeId}`
    );
  }

  getImportedDesign(designId: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/`
    );
  }

  /** Upload a .zip or .html design. Reported with progress: these run to megabytes. */
  uploadImportedDesign(storeId: string, file: File) {
    const form = new FormData();
    form.append('store_id', storeId);
    form.append('file', file, file.name);
    return this.http.post<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/upload/`,
      form,
      { reportProgress: true, observe: 'events' }
    );
  }

  /** Replace a design's boards from a new file, keeping their TV assignments. */
  reimportDesign(designId: number, file: File) {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/reimport/`,
      form
    );
  }

  /** The file a design was imported from, exactly as uploaded (for edit and re-upload). */
  downloadImportedDesign(designId: number) {
    return this.http.get(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/download/`,
      { responseType: 'blob', observe: 'response' }
    );
  }

  deleteImportedDesign(designId: number) {
    return this.http.delete<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/`
    );
  }

  /**
   * Publish a design: every board becomes a Screen, and the screens are grouped
   * onto TVs `boardsPerTv` at a time.
   *
   * One call rather than the per-screen sequence AI Screen Builder runs from the
   * browser — the backend does the whole thing in a transaction, so there is no
   * half-published state to recover from and no 502 risk from parallel creates.
   */
  publishImportedDesign(designId: number, boardsPerTv: number, screenDuration: number) {
    return this.http.post<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/publish/`,
      { boards_per_tv: boardsPerTv, screen_duration: screenDuration }
    );
  }

  /**
   * The menu categories an imported board can be filled from.
   *
   * Deliberately not `getMasterCategory`: that one goes through `orderEndpoint`,
   * which for a Leaflogix store points at the Leaflogix service. Rendering a
   * board reads `RestaurantMasterCategory` from our own database whatever the
   * store type, so the picker has to read the same source — otherwise the tab
   * looks broken on those stores, and any id picked there is not the id the
   * renderer would look up.
   */
  getImportedDesignCategories(storeId: any) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/mastercategories/${storeId}/`
    );
  }

  /** Take a design off its TVs and delete the screens it created. */
  unpublishImportedDesign(designId: number) {
    return this.http.post<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/unpublish/`,
      {}
    );
  }

  /**
   * Point one of a board's lists at menu categories, so it follows the menu
   * instead of showing what the designer typed in. An empty array leaves the
   * designer's own content in place.
   */
  /** Give a design a name of your own — it arrives named after the file. */
  renameImportedDesign(designId: number, name: string) {
    return this.http.patch<any>(
      `${environment.apiUrl}/backend/v2/screen-import/designs/${designId}/`, { name }
    );
  }

  /**
   * A block's row photographs and the items it can be filled from.
   *
   * Fetched per block, when its rows are opened. Both are derived — one parses the
   * stored board, the other reads the menu — and sending them with every design
   * took the list from under half a second to seven.
   */
  getImportedBlockOptions(blockId: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/v2/screen-import/blocks/${blockId}/options/`
    );
  }

  /** Where a row of an imported list can read from — categories and modifier groups. */
  getImportedBlockSources(blockId: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/v2/screen-import/blocks/${blockId}/sources/`
    );
  }

  /**
   * What one source holds. Fetched per choice rather than with the block: a store
   * can have hundreds of modifier groups between them holding thousands of lines,
   * and a row needs one source's worth.
   */
  getImportedBlockLines(blockId: number, sourceKind: string, sourceId: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/backend/v2/screen-import/blocks/${blockId}/lines/` +
      `?source_kind=${encodeURIComponent(sourceKind)}&source_id=${sourceId}`
    );
  }

  /**
   * Change a board's own pictures — the ones that belong to no list.
   *
   * A row's photograph is set on its block; these are the rest, and they had no
   * control anywhere before this. One URL per slot in the order the board holds
   * them, with '' meaning "as the designer supplied".
   */
  updateImportedBoard(boardId: number, changes: { pictures?: string[] }) {
    return this.http.patch<any>(
      `${environment.apiUrl}/backend/v2/screen-import/boards/${boardId}/`,
      changes
    );
  }

  updateImportedBlock(
    blockId: number,
    changes: {
      categories?: number[];
      /** Modifier groups filling the list, alongside the categories. */
      modifier_groups?: number[];
      is_enabled?: boolean;
      max_items?: number | null;
      /** Menu item pinned to each row, `null` where the row follows menu order. */
      item_positions?: (number | null)[];
      /** What each row is set to — source, line, badge text and picture. */
      rows?: any[];
    }
  ) {
    return this.http.patch<any>(
      `${environment.apiUrl}/backend/v2/screen-import/blocks/${blockId}/`,
      changes
    );
  }

}